// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgRedeliveryIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M22 11.74c.14 5.09-3.95 9.26-9 9.26-2.09 0-4-.71-5.52-1.91-.47-.36-.5-1.07-.08-1.49.36-.36.92-.39 1.32-.08C9.9 18.45 11.39 19 13 19c3.9 0 7.05-3.19 7-7.1-.05-3.72-3.18-6.85-6.9-6.9C9.18 4.95 6 8.1 6 12h1.44c.51 0 .76.61.4.97L5.4 15.4c-.22.22-.58.22-.8 0l-2.43-2.43c-.36-.36-.1-.97.4-.97H4c0-5.05 4.17-9.14 9.26-9 4.69.13 8.61 4.05 8.74 8.74M14.5 7h-1.67c-.42 0-.8.27-.95.67l-1.35 3.66c-.13.34.12.71.48.71h.92c.1 0 .18.1.15.2l-1.31 4.56c-.05.16.15.27.26.15l4.34-4.76c.3-.33.07-.88-.37-.88h-1.09c-.11 0-.18-.11-.14-.21l1.22-3.4c.12-.34-.12-.7-.48-.7z" />
  </g>
);
export default SvgRedeliveryIcon;
SvgRedeliveryIcon.displayName = 'SvgRedeliveryIcon';
